"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "ui:layout": "section",
  "ui:title": "Vedlegg",
  "ui:options": {
    "collapsible": true
  },
  "ui:fieldset": ["media"],
  "media": {
    "ui:field": "primusMedia",
    "ui:buttons": ["upload"]
  }
};
exports.default = _default;
module.exports = exports.default;